/**
 * Преобразует число к строке, учитывая склонение
 *
 * @param number Число
 * @param variants 3 варианта склонений [(1) "час", (2) "часа", (5) "часов"]
 *
 * @example
 * num2str(2, ['час', 'часа', 'часа']) // 'часа'
 * num2str(5, ['час', 'часа', 'часа']) // 'часов'
*/
export default function num2str(number: number, variants: string[]) {
	number = Math.abs(number) % 100;
	const n1 = number % 10;
	if (number > 10 && number < 20) return variants[2];
	if (n1 > 1 && n1 < 5) return variants[1];
	if (n1 == 1) return variants[0];
	return variants[2];
}
